exports.TransactionType = {
  TangibleGoods: 'Tangible Goods',
  IntangibleGoods: 'Intangible Goods',
  Loans: 'Loans',
  Services: 'Services'
};